export default {
  "account": {
    "curatedCollections": "Kurátori gyűjtemények",
    "curatedCollectionsInfo": "Az alábbiakban megtalálja az összes gyűjteményt, amelyeket kurált",
    "editProfile": "Profil szerkesztése",
    "likes": "Kedvelések",
    "linkAccount": "Fiókom",
    "linkLogin": "Bejelentkezés",
    "linkLoginJoin": "Bejelentkezés/Csatlakozás",
    "linkLogout": "Bejelentkezés",
    "myProfile": "A profilom",
    "notifications": {
      "loggedIn": "Most már be van jelentkezve. Üdvözlünk!",
      "loggedOut": "Most kijelentkezett.",
      "noCollections": {
        "curated": "Még nem kuratáltál gyűjteményeket",
        "private": "Még nem hozott létre privát galériát",
        "public": "Még nem hozott létre nyilvános galériát"
      },
      "noLikedItems": "Még nem kedvelt egy cikket sem"
    },
    "privateCollections": "Privát Galériák",
    "profile": "Kedveléseim és gyűjteményeim",
    "profileSettings": "Profilbeállítások",
    "publicCollections": "Nyilvános Galériák",
    "settings": "Beállítások",
    "title": "Fiókom"
  },
  "actions": {
    "accept": "Elfogad",
    "cancel": "Mégse",
    "close": "bezárás",
    "continue": "folytatás",
    "download": "Letöltés",
    "edit": "Szerkesztés",
    "feedback": "Visszacsatolás",
    "goBack": "Vissza",
    "goHome": "Ugrás a kezdőlapra",
    "learnMore": "Tudj meg többet",
    "like": "Kedvelés",
    "move": "Mozgás",
    "next": "Következő",
    "pin": "Pin",
    "preview": "Előnézet",
    "previous": "Előző",
    "providedBy": "Szolgáltató: {provider}",
    "reject": "Elutasít",
    "save": "Mentse",
    "send": "Küld",
    "share": "Megosztás",
    "shareOn": "Megosztás a következőn: {social}",
    "skip": "Skip",
    "viewAt": "Megtekintés a következő helyen: {link}",
    "viewDocument": "Dokumentum megtekintése"
  },
  "attribution": {
    "country": "Ország:",
    "creator": "Alkotó:",
    "date": "Dátum:",
    "institution": "Intézmény:",
    "title": "Cím:"
  },
  "automatedCardGroup": {
    "item": "Legutóbbi cikk",
    "organisation": "Szervezetek",
    "place": "Helyek",
    "time": "Kiemelt évszázadok",
    "topic": "Kiemelt témák"
  },
  "blog": {
    "author": "Szerző",
    "authors": "Szerzők",
    "blog": "Blog",
    "by": "írta",
    "categories": "Kategóriák",
    "category": "Kategória",
    "posts": "Blog bejegyzések",
    "published": "Közzététel dátuma: {date}",
    "relatedPosts": "Kapcsolódó bejegyzések"
  },
  "cardLabels": {
    "organisation": "Szervezet",
    "person": "Személy",
    "place": "Hely",
    "theme": "Téma",
    "time": "Század",
    "topic": "Téma"
  },
  "clearAllFilters": "összes szűrő törlése",
  "collections": {
    "actions": {
      "edit": "Gyűjtemény szerkesztése",
      "update": "Gyűjtemény frissítése"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "tervezők",
          "name": "Tervező | Tervezők",
          "select": "Tervezők kiválasztása"
        },
        "proxy_dc_format": {
          "moreName": "technikák",
          "name": "Technika | Technikák",
          "select": "Technikák kiválasztása"
        },
        "proxy_dc_type": {
          "moreName": "elemtípusok",
          "name": "Elemtípus | Elemtípusok",
          "select": "Elemtípusok kiválasztása"
        },
        "proxy_dcterms_medium": {
          "moreName": "anyagok",
          "name": "Anyag | Anyagok",
          "select": "Anyagok kiválasztása"
        }
      }
    },
    "form": {
      "description": "Leírás"
    },
    "notifications": {
      "update": "A gyűjtemény frissült"
    }
  },
  "collectionsYouMightLike": "Gyűjtemények, amelyek tetszhetnek Önnek",
  "colourSwatch": "Színminta",
  "contentYouMightLike": "Tartalom, ami tetszhet Önnek",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "További információ",
      "about": "Az Europeana gyűjteményekről",
      "forDevelopers": "Fejlesztőknek",
      "help": "Súgó",
      "meetUs": "Találkozzon a csapattal",
      "provide": "Legyen adatszolgáltató",
      "subscribe": "Iratkozzon fel hírlevelünkre",
      "terms": "Felhasználási feltételek és adatvédelmi irányelv"
    },
    "headerNavigation": {
      "Collections": "Gyűjtemények",
      "explore": "felfedez",
      "teachers": "Tanárok"
    }
  },
  "curatedAutomatically": "Az Europeana által automatikusan felügyelt",
  "dateFilter": {
    "endDate": "Záró dátum",
    "specificDate": "Konkrét dátum",
    "startDate": "Kezdő dátum",
    "to": "erre"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API kulcs",
      "noRequests": "Ezen az oldalon nem használtak Europeana API-kra vonatkozó kéréseket.",
      "settingsPageLinkText": "beállítások oldalon",
      "tip": "Tipp: ha már rendelkezik {apiKeyLink} , megadhatja azt a {settingsPageLink} oldalon, és ez szerepelni fog ezekben az API-kérés hivatkozásokban.",
      "title": "API kérések"
    },
    "debug": "Debug",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Adja meg Europeana API-kulcsát, és azt az API-kérésekre mutató hivatkozásokban fogja használni.",
          "label": "API kulcs"
        },
        "enabled": {
          "description": "Ha engedélyezve van, a hibakeresési menü megjelenik az oldal láblécében.",
          "label": "Hibakeresési menü engedélyezése"
        }
      },
      "title": "Beállítások"
    }
  },
  "delete": "Törlés",
  "depiction": "{title} ábrázolása",
  "directions": {
    "left": "Bal",
    "right": "Jobb"
  },
  "edmIsShownAtLinkAlt": "Megtekintés a szolgáltató webhelyén",
  "entity": {
    "actions": {
      "cancel": "Mégse",
      "pin": "Elem kitűzője",
      "unpin": "Bontatlan elem",
      "viewPinned": "Lásd a kitűzött elemeket"
    },
    "labels": {
      "entity": "Entitás"
    },
    "notifications": {
      "deleted": "Galéria törölve.",
      "error": {
        "unpin": "Hiba történt az elem rögzítésének feloldásakor. Kérjük, próbálja újra, vagy jelentse a problémát."
      },
      "pin": "Ez az elem a(z) \" {entity} \" gyűjtemény tetején fog megjelenni. Értesítjük, ha ez a változás látható lesz a gyűjtemény oldalán.",
      "pinLimit": {
        "body": "Egyelőre csak 24 elemet rögzíthet az első oldalon. Ha meg szeretné tűzni ezt az elemet, győződjön meg róla, hogy egy másikat bont ki, majd próbálja meg újra rögzíteni.",
        "title": "Túl sok rögzített elem"
      },
      "pinned": "Az elemet kitűzték. Most a gyűjtemény első oldalának tetején található. Lehet, hogy 24 óráig is eltarthat, amíg mindenki számára megjelenik.",
      "select": "Válasszon ki egy kapcsolódó entitást, hogy az elemet hozzá/hozzá kapcsolja/elvegye.",
      "unpin": "Ez az elem nem jelenik meg többé a \"{entity}\" gyűjtemény tetején. Értesítjük Önt, ha ez a változás láthatóvá válik a gyűjtemény oldalán.",
      "unpinned": "Az elem rögzítése megszűnt. Már nincs a gyűjtemény első oldalának tetején. Akár 24 órát is igénybe vehet, amíg mindenki eltűnik."
    }
  },
  "error": "Hiba",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Ez nem lehetséges, mert a privát galériákat csak a készítőjük láthatja. Ha ismeri a galéria készítőjét, kérje meg, hogy tegye nyilvánossá a galériát. Alternatív megoldásként jelentse a problémát a visszajelzés gombbal.",
      "metaTitle": "A galéria jogosulatlan",
      "title": "Hoppá! {newline} Egy másik személy privát galériáját próbálja megtekinteni."
    },
    "itemNotFound": {
      "description": "Ennek a következő okai lehetnek: ez az elem nem létezik, vagy; közzétételre került, mert nem felelt meg minőségi kritériumainknak, vagy; frissítve lett, és új egyedi azonosítóval újból közzétéve, ebben az esetben próbálja meg újra megtalálni az elemet.",
      "metaTitle": "Az elem nem található",
      "title": "Ó, nem! {newline} Nem találtuk meg ezt a tételt."
    }
  },
  "exhibitions": {
    "chapters": "Fejezetek",
    "credits": "Szerzői információk",
    "currentChapter": "Jelenlegi fejezet",
    "description": "Fedezze fel a kiállításokat",
    "exhibitions": "Kiállítások"
  },
  "explore": "fedezze fel",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "színek",
      "name": "Szín | Színek",
      "options": {
        "#000000": "Fekete",
        "#000080": "Sötétkék",
        "#00008B": "Sötétkék",
        "#0000CD": "Közepes kék",
        "#0000FF": "Kék",
        "#006400": "Sötétzöld",
        "#008000": "Web Green",
        "#008080": "A zöldeskék",
        "#008B8B": "Sötét cián",
        "#00BFFF": "Deep Sky Blue",
        "#00CED1": "Sötét türkiz",
        "#00FA9A": "Közepes tavaszi zöld",
        "#00FF00": "Zöld",
        "#00FF7F": "Tavaszi zöld",
        "#00FFFF": "Cián",
        "#191970": "Éjkék",
        "#1E90FF": "Dodger kék",
        "#20B2AA": "Világos tengeri zöld",
        "#228B22": "Erdő zöld",
        "#2E8B57": "Tengerzöld",
        "#2F4F4F": "Sötét pala szürke",
        "#32CD32": "Zöldcitrom zöld",
        "#3CB371": "Közepes tengeri zöld",
        "#40E0D0": "Türkiz",
        "#4169E1": "Királykék",
        "#4682B4": "Acélkék",
        "#483D8B": "Sötét pala kék",
        "#48D1CC": "Közepes türkiz",
        "#4B0082": "Indigó",
        "#556B2F": "Sötét olívazöld",
        "#5F9EA0": "Cadet Blue",
        "#6495ED": "Búzavirág",
        "#663399": "Rebecca Purple",
        "#66CDAA": "Közepes akvamarin",
        "#696969": "Dim Grey",
        "#6A5ACD": "Pala kék",
        "#6B8E23": "Olajbogyó-drapp",
        "#708090": "Pala szürke",
        "#778899": "Világos szürke",
        "#7B68EE": "Közepes pala kék",
        "#7CFC00": "Gyep zöld",
        "#7F0000": "Web Maroon",
        "#7F007F": "Internetes lila",
        "#7FFF00": "Karthauzi likőr",
        "#7FFFD4": "Akvamarin",
        "#800000": "Gesztenyebarna",
        "#800080": "Lila",
        "#808000": "Olajbogyó",
        "#808080": "Internetes szürke",
        "#87CEEB": "Égszínkék",
        "#87CEFA": "Világos égkék",
        "#8A2BE2": "Kék ibolya",
        "#8B0000": "Sötét vörös",
        "#8B008B": "Sötét bíbor",
        "#8B4513": "Nyeregbarna",
        "#8FBC8F": "Sötét tengeri zöld",
        "#90EE90": "Világos zöld",
        "#9370DB": "Közepes lila",
        "#9400D3": "Sötétlila",
        "#98FB98": "Halvány zöld",
        "#9932CC": "Sötét orchidea",
        "#9ACD32": "Sárga zöld",
        "#A020F0": "Lila",
        "#A0522D": "Sienna",
        "#A52A2A": "Barna",
        "#A9A9A9": "Sötétszürke",
        "#ADD8E6": "Világoskék",
        "#ADFF2F": "Zöld sárga",
        "#AFEEEE": "Halvány türkiz",
        "#B03060": "Gesztenyebarna",
        "#B0C4DE": "Világos acélkék",
        "#B0E0E6": "Kobalt kék",
        "#B22222": "Samott",
        "#B8860B": "Sötét aranyvessző",
        "#BA55D3": "Közepes orchidea",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Sötét Khaki",
        "#BEBEBE": "Szürke",
        "#C0C0C0": "Ezüst",
        "#C71585": "Halványlilás piros",
        "#CD5C5C": "Indián vörös",
        "#CD853F": "Peru",
        "#D2691E": "Csokoládé",
        "#D2B48C": "Cser",
        "#D3D3D3": "Világos szürke",
        "#D8BFD8": "Bogáncs",
        "#DA70D6": "Orchidea",
        "#DAA520": "aranyvessző",
        "#DB7093": "Halvány lila piros",
        "#DC143C": "Karmazsinvörös",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Szilva",
        "#DEB887": "Burlywood",
        "#E0FFFF": "Világos ciánkék",
        "#E6E6FA": "Levendula",
        "#E9967A": "Sötét lazac",
        "#EE82EE": "Ibolya",
        "#EEE8AA": "Pale Goldenrod",
        "#F08080": "Világos korall",
        "#F0E68C": "Khaki",
        "#F0F8FF": "Alice kék",
        "#F0FFF0": "Mézharmat",
        "#F0FFFF": "Égszínkék",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Búza",
        "#F5F5DC": "Bézs",
        "#F5F5F5": "Fehér füst",
        "#F5FFFA": "Menta krém",
        "#F8F8FF": "Ghost White",
        "#FA8072": "Lazac",
        "#FAEBD7": "Antik fehér",
        "#FAF0E6": "Vászon",
        "#FAFAD2": "Világos aranyvessző",
        "#FDF5E6": "Régi csipke",
        "#FF0000": "Piros",
        "#FF00FF": "Fukszia",
        "#FF1493": "Mély rózsaszín",
        "#FF4500": "Narancsvörös",
        "#FF6347": "Paradicsom",
        "#FF69B4": "Dögös rózsaszín",
        "#FF7F50": "Korall",
        "#FF8C00": "Sötét narancs",
        "#FFA07A": "Halványsárga",
        "#FFA500": "narancssárga",
        "#FFB6C1": "Világos rózsaszín",
        "#FFC0CB": "Rózsaszín",
        "#FFD700": "Arany",
        "#FFDAB9": "Őszibarack puff",
        "#FFDEAD": "Navajo White",
        "#FFE4B5": "Mokaszin",
        "#FFE4C4": "Krémleves",
        "#FFE4E1": "Ködös Rose",
        "#FFEBCD": "Blanched mandula",
        "#FFEFD5": "Papaya Whip",
        "#FFF0F5": "Levendula elpirul",
        "#FFF5EE": "Seashell",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Citrom sifon",
        "#FFFAF0": "Virágos fehér",
        "#FFFAFA": "Hó",
        "#FFFF00": "Sárga",
        "#FFFFE0": "Halványsárga",
        "#FFFFF0": "Elefántcsont",
        "#FFFFFF": "fehér"
      },
      "select": "Válasszon színeket"
    },
    "COUNTRY": {
      "name": "Szolgáltató ország",
      "options": {
        "Albania": "Albánia",
        "Austria": "Ausztria",
        "Belarus": "Fehéroroszország",
        "Belgium": "Belgium",
        "Bosnia and Herzegovina": "Bosznia-Hercegovina",
        "Bulgaria": "Bulgária",
        "Croatia": "Horvátország",
        "Cyprus": "Ciprus",
        "Czech Republic": "Cseh Köztársaság",
        "Denmark": "Dánia",
        "Estonia": "Észtország",
        "Europe": "Európa",
        "Finland": "Finnország",
        "France": "Franciaország",
        "Georgia": "Grúzia",
        "Germany": "Németország",
        "Greece": "Görögország",
        "Holy See (Vatican City State)": "Szentszék (Vatikánváros Állam)",
        "Hungary": "Magyarország",
        "Iceland": "Izland",
        "Ireland": "Írország",
        "Israel": "Izrael",
        "Italy": "Olaszország",
        "Latvia": "Lettország",
        "Lithuania": "Litvánia",
        "Luxembourg": "Luxemburg",
        "Macedonia": "Macedónia",
        "Malta": "Málta",
        "Moldova": "Moldova",
        "Montenegro": "Montenegró",
        "Netherlands": "Hollandia",
        "Norway": "Norvégia",
        "Poland": "Lengyelország",
        "Portugal": "Portugália",
        "Romania": "Románia",
        "Russia": "Oroszország",
        "Serbia": "Szerbia",
        "Slovakia": "Szlovákia",
        "Slovenia": "Szlovénia",
        "Spain": "Spanyolország",
        "Sweden": "Svédország",
        "Switzerland": "Svájc",
        "Turkey": "Törökország",
        "Ukraine": "Ukrajna",
        "United Kingdom": "Egyesült Királyság",
        "United States of America": "Amerikai Egyesült Államok"
      },
      "select": "Válassza ki az ellátó országokat"
    },
    "CREATOR": {
      "moreName": "alkotók",
      "name": "Alkotó | Alkotók",
      "select": "Válasszon alkotókat"
    },
    "DATA_PROVIDER": {
      "moreName": "intézmények",
      "name": "Intézmény",
      "select": "Válasszon intézményeket"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Képtájolás | Képtájolások",
      "options": {
        "landscape": "Fekvő",
        "portrait": "Álló"
      },
      "select": "Válassza ki a kép tájolását"
    },
    "IMAGE_SIZE": {
      "name": "Képméret | Képméretek",
      "options": {
        "extra_large": "Extra nagy, 4MP+ (pl. 2688 x 1520 képpont)",
        "large": "Nagy, 1-4 MP + (pl.1920 x 1080 képpont)",
        "medium": "Közepes, 0,5-1MP (pl. 850 x 850 képpont)",
        "small": "Kicsi, < 0,5 MP (pl. 650 x 600 képpont)"
      },
      "select": "Válassza ki a képméreteket"
    },
    "LANGUAGE": {
      "name": "Nyelv",
      "options": {
        "ar": "Arab",
        "bg": "Bolgár",
        "bs": "Boszniai",
        "ca": "Katalán",
        "cs": "Cseh",
        "cy": "Walesi",
        "da": "Dán",
        "de": "Német",
        "el": "Görög",
        "en": "Angol",
        "es": "Spanyol",
        "et": "Észt",
        "fi": "Finn",
        "fr": "Francia",
        "ga": "Ír",
        "gd": "Gael",
        "he": "Héber",
        "hr": "Horvát",
        "hu": "Magyar",
        "is": "Izlandi",
        "it": "Olasz",
        "lt": "Litván",
        "lv": "Lett",
        "mk": "Macedón",
        "mt": "Máltai",
        "mul": "Több nyelv",
        "nl": "Holland",
        "no": "Norvég",
        "pl": "Lengyel",
        "pt": "Portugál",
        "ro": "Román",
        "ru": "Orosz",
        "sk": "Szlovák",
        "sl": "Szlovén",
        "sq": "Albán",
        "sr": "Szerb",
        "sv": "Svéd",
        "tr": "Török",
        "uk": "Ukrán"
      },
      "select": "Nyelvek kiválasztása"
    },
    "MIME_TYPE": {
      "name": "Fájlformátum | Fájlformátumok",
      "options": {
        "text/plain": "Egyszerű szöveg"
      },
      "select": "Válassza ki a fájlformátumokat"
    },
    "PROVIDER": {
      "moreName": "aggregátorok",
      "name": "Aggregátor",
      "select": "Válasszon aggregátorokat"
    },
    "REUSABILITY": {
      "name": "Használhatom ezt újból?",
      "options": {
        "open": "igen",
        "permission": "Talán, kérjen engedélyt",
        "restricted": "Igen, feltételekkel",
        "uncategorized": "Uncategorized"
      },
      "select": "Válassza ki, hogy használhatja-e ezt"
    },
    "TYPE": {
      "name": "Adathordozó típusa",
      "options": {
        "3D": "3D",
        "IMAGE": "Kép",
        "SOUND": "Hang",
        "TEXT": "Szöveg",
        "VIDEO": "Videó"
      },
      "select": "Adathordozó-típusok kiválasztása"
    },
    "api": {
      "name": "Keresés erre",
      "options": {
        "fulltext": "Rekordok teljes szöveggel",
        "metadata": "Csak metaadatokat tartalmazó rekordok"
      },
      "switch": "Keresés csak a teljes szövegű elemek tartalmában",
      "switchMoreInfo": "Ebben a gyűjteményben kiválaszthatja, hogy mit szeretne keresni: ha ez a kapcsoló be van kapcsolva, akkor az újság és a dokumentum szövegében fog keresni; ha ki van kapcsolva, akkor inkább a tárgyat leíró információk között fog keresni, ahogyan a legtöbb más gyűjteményben is."
    },
    "button": {
      "apply": "Alkalmaz",
      "cancel": "Mégse",
      "morefilters": "További szűrők",
      "reset": "Visszaállítás",
      "showAll": "Összes {label} megjelenítése",
      "showLess": "Kevesebb {label} megjelenítése"
    },
    "collection": {
      "name": "Téma",
      "options": {
        "archaeology": "Régészet",
        "art": "Művészet",
        "fashion": "Divat",
        "industrial": "Ipari örökség",
        "manuscript": "Kéziratok",
        "map": "Térképek és földrajz",
        "migration": "Migráció",
        "music": "Zene",
        "nature": "Természettörténet",
        "newspaper": "Újságok",
        "photography": "Fotózás",
        "sport": "Sport",
        "ww1": "Első világháború"
      },
      "select": "Téma kiválasztása"
    },
    "contentTier": {
      "name": "Minősége elemek",
      "options": {
        "*": "A közzétételi feltételeknek meg nem felelő elemek kizárása",
        "0": "Csak olyan cikkek megjelenítése, amelyek nem felelnek meg a közzétételi kritériumoknak",
        "1": "Gyenge minőség",
        "2": "Közepes minőség",
        "3": "Kiváló minőségű és újrafelhasználható feltételekkel",
        "4": "Kiváló minőségű és szabadon újrafelhasználható"
      },
      "select": "Cikkminőségek kiválasztása"
    },
    "moreOptions": "Keresés, hogy találjon {0} több {1}.",
    "proxy_dc_format": {
      "name": "Formátum | formátumok",
      "select": "Formátumok kiválasztása"
    },
    "proxy_dc_type": {
      "name": "Típus | Típusok",
      "select": "Típusok kiválasztása"
    },
    "proxy_dcterms_issued": {
      "name": "Kibocsátás dátuma"
    },
    "proxy_dcterms_medium": {
      "name": "Adathordozó | Adathordozók",
      "select": "Adathordozó kiválasztása"
    }
  },
  "feedback": {
    "emailOptional": "Érdemes lehet utánajárnunk. Írja be az e-mail címét, ha örül, hogy kapcsolatba lépünk Önnel.",
    "failed": "A kérés nem sikerült. Kérlek próbáld újra.",
    "form": {
      "placeholders": {
        "email": "Adja meg e-mail címét",
        "feedback": "Írja be ide visszajelzését"
      }
    },
    "policies": "A folytatással elfogadja {0} és a {1} .",
    "privacyPolicy": "Adatvédelmi irányelvek",
    "success": "Visszajelzését elküldtük.",
    "termsOfService": "Szolgáltatás feltételei",
    "thankYou": "Köszönöm!",
    "title": "Visszajelzés küldése",
    "validEmail": "Adjon meg egy érvényes email címet",
    "validFeedback": "A visszajelzésnek legalább 5 szóból kell állnia"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Közreműködők",
      "dcCoverage": "Hely-idő",
      "dcCreator": "Alkotó",
      "dcDate": "Dátum",
      "dcDescription": "Leírás",
      "dcDuration": "Időtartam",
      "dcFormat": "Formátum",
      "dcIdentifier": "Azonosító",
      "dcLanguage": "Nyelv",
      "dcPublisher": "Kiadó",
      "dcRelation": "Kapcsolatok",
      "dcRights": "Jogok",
      "dcSource": "Forrás",
      "dcSubject": "Tárgy",
      "dcTitle": "Cím",
      "dcType": "Objektum típusa",
      "dctermsCreated": "Létrehozás dátuma",
      "dctermsExtent": "Terjedelem",
      "dctermsHasPart": "Tartalma",
      "dctermsHasVersion": "Verziószáma",
      "dctermsIsFormatOf": "Formátuma",
      "dctermsIsPartOf": "Része",
      "dctermsIsReferencedBy": "Hivatkozik rá",
      "dctermsIsReplacedBy": "Lecserélve a következővel",
      "dctermsIsRequiredBy": "Megköveteli",
      "dctermsIssued": "Kiadás dátuma",
      "dctermsMedium": "Közepes",
      "dctermsProvenance": "Származási hely",
      "dctermsReferences": "Hivatkozások",
      "dctermsSpatial": "Helyek",
      "dctermsTOC": "Tartalomjegyzék",
      "dctermsTemporal": "Időbeli",
      "edmCountry": "Szolgáltató ország",
      "edmCurrentLocation": "Jelenlegi tartózkodási hely",
      "edmDataProvider": "Szolgáltató intézmény",
      "edmHasMet": "Teljesítette",
      "edmIncorporates": "Magában foglalja",
      "edmIntermediateProvider": "Köztes szolgáltató",
      "edmIsDerivativeOf": "Leszármazottja",
      "edmIsRelatedTo": "Kapcsolódik a",
      "edmIsRepresentationOf": "Képviselete",
      "edmIsSimilarTo": "Hasonló",
      "edmIsSuccessorOf": "Utódja",
      "edmProvider": "Szolgáltató",
      "edmRealizes": "Rájön",
      "edmRights": "Az ebben a nyilvántartásban szereplő adathordozó licence (hacsak másképp nincs meghatározva)",
      "edmUgc": "Felhasználó által generált tartalom",
      "europeanaCollectionName": "Gyűjtemény neve",
      "keywords": "Kulcsszavak (a közösség által megadva)",
      "timestampCreated": "Időbélyeg létrehozva",
      "timestampUpdate": "Időbélyeg frissítve",
      "wasPresentAt": "Jelen volt itt",
      "year": "Év"
    },
    "webResource": {
      "about": "RDF Névjegy",
      "dcDescription": "Leírás",
      "ebucoreHasMimeType": "Ebucore MIME típus",
      "edmRights": "Licenc ehhez a média-erőforráshoz",
      "rdfAbout": "RDF Névjegy"
    }
  },
  "filter": "Szűrő",
  "filterResults": "Eredmények szűrése",
  "footer": {
    "customiseWebsiteLanguage": "A webhely nyelvének testreszabása",
    "disclaimerLine1": "Az Europeana az Európai Unió kezdeményezése, amelyet az Európai Unió Európai Uniót összekötő eszközének és az Európai Unió tagállamainak finanszíroz. Az Europeana szolgáltatásait, beleértve ezt a weboldalt is, az Europeana Alapítvány által vezetett konzorcium üzemelteti az Európai Bizottsággal kötött szolgáltatási szerződés alapján.",
    "disclaimerLine2": "Az Európai Bizottság nem garantálja az információk pontosságát, és semmilyen felelősséget nem vállal a weboldalon található információkkal kapcsolatban. Sem az Európai Bizottság, sem az Európai Bizottság nevében eljáró személyek nem felelősek vagy felelősek a weboldalon található információk pontosságáért vagy felhasználásáért.",
    "findUsElsewhere": "Keressen minket máshol",
    "imageDescription": "Az Európai Unió által finanszírozott",
    "navigation": {
      "MoreInfoLabel": "További információ",
      "about": "Rólunk",
      "accessibility": "Hozzáférhetőség",
      "cookies": "Sütik",
      "forDevelopers": "Fejlesztőknek",
      "help": "Súgó",
      "privacy": "Adatvédelmi irányelvek",
      "provide": "Legyen adatszolgáltató",
      "subscribe": "Iratkozzon fel hírlevelünkre",
      "terms": "Szolgáltatás feltételei"
    },
    "ourMission": "Küldetésünk",
    "ourMissionQuote": "Az Europeana segíti a kulturális örökség ágazatát a digitális átalakulásban. Szakértelmet, eszközöket és irányelveket dolgozunk ki a digitális változások befogadására és az innovációt elősegítő partnerségek ösztönzésére."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Fedezze fel galériáinkat",
    "galleries": "Galériák"
  },
  "goToRecord": "Ugrás a rekordra",
  "header": {
    "backToMenu": "Keresőmező bezárása",
    "clearQuery": "Keresőkifejezés törlése",
    "closeSidebar": "Menü bezárása",
    "entireCollection": "Keresés az egész gyűjteményben erre: {query}",
    "europeanaHome": "Europeana kezdőlap",
    "inCollection": "Keresés erre: {query}, a {collection} gyűjteményben",
    "navigation": {
      "about": "Rólunk",
      "collections": "Gyűjtemények",
      "europeanaClassroom": "A tanároknak",
      "help": "Súgó",
      "home": "itthon",
      "pro": "Szakembereknek",
      "stories": "Történetek"
    },
    "quickSearch": "Gyors keresés",
    "searchFor": "Keresés erre: {query}",
    "searchForEverything": "Keresés mindenre",
    "searchForEverythingInCollection": "Keresés mindenre a(z) {collection} gyűjteményben",
    "searchForEverythingInEntireCollection": "Keresés mindenre az egész gyűjteményben",
    "searchForm": "Keresés űrlap",
    "showSidebar": "Menü mutatása",
    "sideNavigation": "Oldalsó navigáció"
  },
  "homeLinkAlt": "Europeana kezdőlap",
  "homePage": {
    "discoverEditorial": "Legújabb történetek",
    "storiesCTA": "Az összes történet megtekintése",
    "subHeadline": "Válogasson több ezer kulturális intézmény művészeti alkotásaiból, könyveiből,filmjeiből és zeneműveiből, és mentse el vagy ossza meg kedvenceit",
    "themesCTA": "Az összes téma megtekintése",
    "themesTitle": "fedezze fel a témát",
    "title": "Fedezze fel Európa {digital} kulturális örökségét",
    "titleDigital": "digitális"
  },
  "imageSlider": {
    "handle": "Csúszka fogantyú"
  },
  "items": {
    "itemCount": "1 cikk |{count} cikk",
    "itemOf": "{max} {count} cikk",
    "recent": "Legutóbbi elemek",
    "recommended": "Ajánlott tételek",
    "youMightLike": "Cikkek, amik tetszhetnek Önnek"
  },
  "klaro": {
    "main": {
      "acceptAll": "Elfogadni minden",
      "acceptSelected": "Kiválasztott elfogadása",
      "consentModal": {
        "description": "Komolyan vesszük az Ön adatvédelmét. Itt értékelheti és testre szabhatja azokat a szolgáltatásokat, amelyeket ezen a weboldalon használni szeretnénk. Te vagy a felelős! Engedélyezze vagy tiltsa le a szolgáltatásokat tetszése szerint.",
        "title": "Szolgáltatások, amelyeket szeretnénk igénybe venni."
      },
      "consentNotice": {
        "description": "Törődünk az adatvédelemmel, és csak az élmény javítása érdekében használunk adatokat. Nem használunk személyes adatokat reklámozásra. 15 naponta módosíthatja beleegyezését.",
        "learnMore": "Hadd válasszam"
      },
      "decline": "Elutasítom",
      "ok": "oké",
      "purposes": {
        "essential": {
          "description": "Ezek a szolgáltatások elengedhetetlenek a weboldal megfelelő működéséhez. Tartalmazzák a keresési eredmények nézetét és a nyelvi beállításokat, megőrzik a bejelentkezett állapotot és biztonságban tartják látogatásukat. Nem tilthatja le őket, mivel a webhely egyébként nem működne megfelelően.",
          "title": "Alapvető szolgáltatások a biztonság és a testreszabás érdekében"
        },
        "usage": {
          "description": "Ezek a szolgáltatások összegyűjtik az információkat, hogy jobban megértsük, hogyan használják fel a weboldalt és hol vannak a fájdalompontok, felhatalmazva bennünket arra, hogy megalapozott döntéseket hozzunk az Ön élményének javítása érdekében.",
          "title": "Szolgáltatások a weboldal használatának és visszajelzésének rögzítésére"
        }
      },
      "service": {
        "disableAll": {
          "description": "Ezzel a kapcsolóval engedélyezheti vagy letilthatja az összes opcionális szolgáltatást.",
          "title": "Minden szolgáltatás engedélyezése vagy letiltása"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Segít weboldalunk fejlesztésében azáltal, hogy alkalmanként kísérleti változtatásokat alkalmaz.",
        "title": "A/B tesztelés"
      },
      "auth-strategy": {
        "description": "Emlékszik a bejelentkezéshez használandó engedélyezési stratégiára.",
        "title": "Auth stratégia"
      },
      "debugSettings": {
        "description": "Segít az API -kérelmek hibakeresésében",
        "title": "Hibakeresés váltás"
      },
      "hotjar": {
        "description": "Aktivál egy felmérési widgetet, amely lehetőséget ad a látogatói elégedettségi felméréseinkre való válaszadásra.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Emlékszik az Ön által preferált felület nyelvére a későbbi hozzáférés érdekében.",
        "title": "Nyelvi kód"
      },
      "jira-servicedesk": {
        "description": "Aktiválja a visszajelzés widgetet, amely lehetőséget ad a kapcsolatfelvételre.",
        "title": "Jira szolgáltató pult"
      },
      "matomo": {
        "description": "Névtelen statisztikákat gyűjt arról, hogy a látogatók hogyan lépnek kapcsolatba a weboldallal.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Értesítést jelenít meg, ha új funkciók válnak elérhetővé.",
        "title": "Új funkció értesítése"
      },
      "searchResultsView": {
        "description": "Emlékszik arra, hogy a keresési eredményeket inkább lista- vagy rácsnézetben szeretné-e látni.",
        "title": "Keresési eredmény nézet (lista / rács)"
      }
    }
  },
  "layout": {
    "skipToMain": "Ugrás az oldal tartalmához"
  },
  "learnMore": "Tudjon meg többet a leírás forrásáról",
  "loading": "Betöltés",
  "loadingResults": "Eredmények betöltése",
  "messages": {
    "copyToClipboardSuccess": "Vágólapra másolva",
    "externalContentError": "A külső tartalom betöltése sikertelen",
    "notFound": "Nem található",
    "paginationLimitExceeded": "Csak az első {limit} keresési találat tekinthető meg."
  },
  "modal": {
    "download": {
      "clickToCopy": "Kattintson az attribútumra a másoláshoz",
      "modalIntro": "Ha ezt az elemet használja az interneten vagy máshol, ne felejtse el megjeleníteni a következő attribútumot mellette:",
      "modalTitle": "Mondj köszönetet"
    }
  },
  "multilingual": {
    "automated": "Automatizált fordítás",
    "enrichment": "Gazdagodás partnerprojektek által",
    "other": "Egyéb nyelvek",
    "stopTranslating": "Állítsa le ennek az elemnek a fordítását {0}-ra.",
    "translateLanguage": "Szeretné látni ezt az elemet itt: {0} ?",
    "translateQuotaError": "A fordítási szolgáltatás ideiglenesen nem érhető el. Kérlek, próbáld újra később."
  },
  "newFeatureNotification": {
    "dismiss": "Bezárás",
    "readMore": "Bővebben",
    "text": {
      "searchFilters": "Most már kereshet értékeket az egyes szűrőkben; nézd meg!"
    }
  },
  "newWindow": "új ablakban nyílik meg",
  "noMoreResults": "Nincs további eredmény a keresési lekérdezéshez.",
  "noResults": "Nincs találat",
  "of": "A",
  "organisation": {
    "city": "Város",
    "country": "Ország",
    "englishName": "Angol név",
    "nameAcronym": "Név rövidítés"
  },
  "pageHasLoaded": "betöltődött",
  "pageNumber": "Oldalszám",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Név"
        },
        "title": "Szervezetek"
      },
      "persons": {
        "title": "Személyek"
      },
      "places": {
        "title": "Helyek"
      },
      "table": {
        "items": "Tételek",
        "name": "Név"
      },
      "times": {
        "title": "Idők"
      },
      "topics": {
        "title": "Témák"
      }
    }
  },
  "pagination": {
    "label": "Lapszámozás"
  },
  "readMore": "Bővebben",
  "recommendation": {
    "prompts": {
      "accept": "Hüvelykujj felfelé, hogy hozzáadjuk a galériához",
      "reject": "Hüvelykujj le, ha nem tetszik"
    }
  },
  "record": {
    "IIIFViewer": "IIIF néző",
    "actions": {
      "pin": "Az elem rögzítése az elérhető entitásokhoz"
    },
    "allMetaData": "Minden metaadat",
    "copyEmbedLabel": "Beágyazási kód (Kattintson a másoláshoz)",
    "exploreMore": "Fedezz fel többet",
    "extendedInformation": "Kiterjesztett információk",
    "goodToKnow": "Jó tudni",
    "hideAll": "Az összes információ elrejtése",
    "location": "hely",
    "locationOnMap": "Elhelyezkedés a térképen",
    "mediaPlayer": "Médialejátszó",
    "record": "Rekord",
    "showAll": "Az összes információ megjelenítése",
    "similarItems": "Hasonló elemek",
    "status": {
      "unpublished": "[Közzé nem tett tétel]"
    },
    "transcription": "Átírás",
    "transcriptionDisclaimer": "Ezt a tartalmat a nyilvánosság hozza létre, nem az intézmény, amely a cikket szolgáltatta."
  },
  "related": {
    "editorial": {
      "title": "Történetek, amelyek tetszhetnek"
    }
  },
  "relatedCollections": "Kapcsolódó gyűjtemények",
  "removeFilter": "{filterLabel} szűrő eltávolítása",
  "reset": "Visszaállítás",
  "resourceWikimedia": "Forrás: Wikimedia Commons",
  "results": "Találatok",
  "resultsFor": "Találatok a következőre: {0}",
  "resultsLimitWarning": "Nem jelennek meg további eredmények, mivel csak az első 1000 legrelevánsabb eredmény látható. Ha nem találta meg azt, amit keres, kérjük, finomítsa a keresést.",
  "resultsWithin": "Találatok a következőn belül {0} {1} a következőre: {2}",
  "search": {
    "boost": {
      "placeholder": "Adja meg a mezőt növelő lekérdezést"
    },
    "title": "Keresés"
  },
  "searchHasLoaded": "{0} eredmények visszaadva",
  "searchPlaceholder": "Keresés 50+ millió tételben",
  "searchResults": "Keresés",
  "searchResultsFor": "{0} - Keresés",
  "searchSuggestions": "Keresési javaslatok",
  "searchTier": {
    "button": {
      "hide": "Ezen elemek elrejtése",
      "show": "Ezen elemek megjelenítése"
    },
    "text": {
      "hide": "Megjelennek azok az elemek, amelyek nem felelnek meg a közzétételi kritériumoknak.",
      "show": "Több elem megfelel a keresésnek, de nem felel meg a közzétételi kritériumoknak."
    }
  },
  "searchViews": {
    "grid": "Rácsnézet",
    "list": "Listanézet",
    "mosaic": "Mozaik nézet"
  },
  "set": {
    "actions": {
      "addTo": "Hozzáadás a gelériához",
      "create": "Galéria létrehozása",
      "createNew": "Új galéria létrehozása",
      "delete": "Galéria törlése",
      "edit": "Galéria szerkesztése",
      "update": "Galéria frissítése"
    },
    "form": {
      "description": "Galéria leírása",
      "private": "Galéria privát módban tartása",
      "required": "Kötelező mező",
      "title": "Galéria neve"
    },
    "labels": {
      "curatedBy": "Kurátor:",
      "private": "Privát galéria"
    },
    "notifications": {
      "deleted": "Galéria törölve.",
      "likeLimit": {
        "body": "Sajnáljuk, de jelenleg legfeljebb 100 cikket kedvelhet. Hamarosan eltávolítjuk ezt a korlátozást!",
        "title": "100 kedvelés"
      },
      "updated": "Az elem felkerült a galériába."
    },
    "prompts": {
      "delete": "Biztosan törli ezt a galériát? Ha törli a galériát, elveszíti az összes hozzáadott elemet."
    }
  },
  "showLess": "Kevesebb megjelenítése",
  "showMore": "Továbbiak megjelenítése",
  "sideFilters": {
    "noOptions": "Nincsenek választható opciók",
    "search": "Keresés"
  },
  "statuses": {
    "liked": "Tetszett",
    "pinned": "Odatűzött"
  },
  "storiesPage": {
    "title": "Történetek"
  },
  "website": "Weboldal",
  "youMightAlsoLike": "Ez is érdekelheti Önt"
};
